import { Button } from '@bienenkampf/ui';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { pushState, subscribePush, unsubscribePush, type PushState } from '../lib/push.js';
import { useTRPC } from '../lib/trpc.js';

/** Schalter fuer Web Push: Angriffe, Koeniginnen, Winter, Erwaehnungen. */
export function PushToggle() {
  const trpc = useTRPC();
  const key = useQuery(trpc.push.publicKey.queryOptions());
  const [state, setState] = useState<PushState>('off');
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    void pushState().then(setState);
  }, []);
  const subscribe = useMutation(trpc.push.subscribe.mutationOptions());
  const unsubscribe = useMutation(trpc.push.unsubscribe.mutationOptions());
  const test = useMutation(trpc.push.test.mutationOptions());

  if (state === 'unsupported' || key.data?.key === null) return null;

  const enable = async () => {
    setError(null);
    try {
      const sub = await subscribePush(key.data!.key!);
      await subscribe.mutateAsync(sub);
      setState('on');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Push konnte nicht aktiviert werden');
      setState(await pushState());
    }
  };
  const disable = async () => {
    const endpoint = await unsubscribePush();
    if (endpoint) await unsubscribe.mutateAsync({ endpoint });
    setState('off');
  };

  return (
    <span className="ml-auto flex items-center gap-1 text-xs">
      {state === 'on' ? (
        <>
          <Button
            size="sm"
            variant="ghost"
            onClick={() => test.mutate()}
            loading={test.isPending}
            title="Testnachricht senden"
          >
            🔔 Push aktiv
          </Button>
          <Button size="sm" variant="ghost" onClick={() => void disable()} title="Push abschalten">
            ✕
          </Button>
        </>
      ) : state === 'denied' ? (
        <span className="text-stone-500" title="Im Browser für diese Seite erlauben">
          🔕 Push blockiert
        </span>
      ) : (
        <Button
          size="sm"
          variant="ghost"
          onClick={() => void enable()}
          loading={subscribe.isPending || !key.data}
        >
          🔔 Push aktivieren
        </Button>
      )}
      {error && <span className="text-red-400">{error}</span>}
    </span>
  );
}
